import { combineEpics, ofType } from 'redux-observable';
import { timer } from 'rxjs';
import { map, pluck, delayWhen } from 'rxjs/operators';

import { notifications } from '../../notifications';

const addNotificationEpic = (action$) => action$.pipe(
  ofType(notifications.add),
  pluck('payload'),
  delayWhen(({ delayTime }) => timer(delayTime)),
  map(notifications.remove),
);

export default combineEpics(addNotificationEpic);
